<ng-container *ngIf="product">
  <app-header [pageTitle]="''+product.name+''" [back]="'modal'"></app-header>
  <ion-content>
    <div class="container mt-2 mb-3">
      <ion-grid [fixed]="true">
        <ng-container>
          <form [formGroup]="form" *ngIf="form">
            <ion-row>
              <ion-col size="12">
                <ion-card class="card card_highlight">
                  <ion-card-content class="card__content">
                    <ng-container *ngFor="let field of FIELDS">
                      <h3 class="title-h3" *ngIf="field.title">{{field.title}}</h3>
                      <div class="input-form-group" [ngSwitch]="true" [ngClass]="field.type === propertyType.Range ? 'sizes_group' : null">
                        <ng-container *ngSwitchCase="field.type === propertyType.Number || field.type === propertyType.Text || field.type === propertyType.Range">
                          <ion-label class="input-label">
                            {{field.name}}<sup class="input-required-symbol" *ngIf="field.validators.length">*</sup>
                            <span class="sublabel" *ngIf="field.subtitle" [innerHTML]="field.subtitle"></span>
                          </ion-label>
                          <ion-input class="input" [type]="field.type === propertyType.Number || field.type === propertyType.Range ? 'number' : null" (ionBlur)="saveField(field.alias)" formControlName="{{field.alias}}"></ion-input>
                          <ion-note class="input-error" *ngIf="form.get(field.alias)?.touched && form.get(field.alias)?.invalid" slot="error">Введите {{field.name.toLowerCase()}}</ion-note>
                        </ng-container>
                        <ng-container *ngSwitchCase="field.type === propertyType.Select">
                          <ion-label class="input-label">{{field.name}}</ion-label>
                          <ion-select
                            class="input input-select"
                            (ionChange)="saveField(field.alias)"
                            formControlName="{{field.alias}}"
                            interface="alert"
                            okText="Выбрать"
                            cancelText="Отмена">
                            <ng-container *ngFor="let prop of getProportions(field.alias)">
                              <ion-select-option [value]="prop.value">{{prop.text || prop.value}}</ion-select-option>
                            </ng-container>
                          </ion-select>
                        </ng-container>
                        <ng-container *ngSwitchCase="field.type === propertyType.Textarea">
                          <ion-label class="input-label">{{field.name}}</ion-label>
                          <ion-textarea class="input input-textarea"
                                        (ionBlur)="saveField(field.alias)"
                                        formControlName="{{field.alias}}">
                          </ion-textarea>
                        </ng-container>
                      </div>
                    </ng-container>
                  </ion-card-content>
                </ion-card>
              </ion-col>
            </ion-row>
          </form>
        </ng-container>
        <ng-container>
          <form [formGroup]="formProperty" *ngIf="formProperty && form && form.get('categoryId')?.valid && FIELDS_PROPERTY.length > 0">
            <ion-row>
              <ion-col size="12">
                <ion-card class="card card_highlight">
                  <ion-card-content class="card__content">
                    <ng-container *ngFor="let field of FIELDS_PROPERTY">
                      <h3 class="title-h3" *ngIf="field.title">{{field.title}}</h3>
                      <div class="input-form-group" [ngSwitch]="true" [ngClass]="field.type === propertyType.Range ? 'sizes_group' : null">
                        <ng-container *ngSwitchCase="field.type === propertyType.Number || field.type === propertyType.Text || field.type === propertyType.Range && !field.fromList">
                          <ion-label class="input-label">
                            {{field.name}}<sup class="input-required-symbol" *ngIf="field.validators.length">*</sup>
                            <span class="sublabel" *ngIf="field.subtitle" [innerHTML]="field.subtitle"></span>
                          </ion-label>
                          <ion-input class="input" [type]="field.type === propertyType.Number || field.type === propertyType.Range ? 'number' : null" (ionBlur)="saveField(field.alias)" formControlName="{{field.alias}}"></ion-input>
                          <ion-note class="input-error" *ngIf="formProperty.get(field.alias)?.touched && formProperty.get(field.alias)?.invalid" slot="error">Введите {{field.name.toLowerCase()}}</ion-note>
                        </ng-container>
                        <ng-container *ngSwitchCase="field.fromList">
                          <ion-label class="input-label">{{field.name}}</ion-label>
                          <ion-select
                            class="input input-select"
                            (ionChange)="saveField(field.alias)"
                            formControlName="{{field.alias}}"
                            interface="alert"
                            okText="Выбрать"
                            cancelText="Отмена">
                            <ng-container *ngFor="let prop of getProportions(field.alias); let i = index;">
                              <ion-select-option *ngIf="i == 0" [value]="'null'">Не указано</ion-select-option>
                              <ion-select-option *ngIf="i > 0" [value]="prop.value">{{prop.text || prop.value}}</ion-select-option>
                            </ng-container>
                          </ion-select>
                          <ng-container *ngIf="getProportions(field.alias, true).length > 0 && getProportions(field.alias, true)[0]?.isFree && getProportions(field.alias, true)[0]?.value == formProperty.get(field.alias)?.value">
                            <ion-label class="input-label">
                              Свой вариант
                            </ion-label>
                            <ion-input class="input" (ionChange)="saveField(field.alias)" formControlName="{{field.alias}}_free"></ion-input>
                          </ng-container>
                        </ng-container>
                        <ng-container *ngSwitchCase="field.type === propertyType.Textarea">
                          <ion-label class="input-label">{{field.name}}</ion-label>
                          <ion-textarea class="input input-textarea"
                                        (ionBlur)="saveField(field.alias)"
                                        formControlName="{{field.alias}}">
                          </ion-textarea>
                        </ng-container>
                      </div>
                    </ng-container>
                  </ion-card-content>
                </ion-card>
              </ion-col>
            </ion-row>
          </form>
        </ng-container>
        <ion-row>
          <ion-col size="12">
            <h3 class="title-h3">Фото</h3>
            <div class="photo__section">
              <app-slider [photosIds]="product.photosIds" [sliderMode]="'linear'" [hasPhotoRemover]="true" (removeClick)="mediaRemove($event)"></app-slider>
              <ngx-file-drop class="mt-3" dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)" [multiple]="true">
                <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                  <ion-button shape="round" fill="clear" class="button button_add button_add_light" (click)="openFileSelector()"><ion-icon name="add-outline"></ion-icon></ion-button>
                </ng-template>
              </ngx-file-drop>
            </div>
            <p class="mt-3">
              <sup class="input-required-symbol">* </sup> - обязательные поля
            </p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12">
            <div class="card__buttons mt-3">
              <ion-button shape="round" color="danger" class="button button_round" (click)="send(true)" [disabled]="isSend">Опубликовать</ion-button>
              <ion-button shape="round" class="button button_round button_light mt-1" (click)="send()" [disabled]="isSend">В черновик</ion-button>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </ion-content>
</ng-container>
